import { getBlobUrl } from '../../../helpers/getBlobUrl';

export const download = ({ data, report }) => {
  if (!data) return;

  const { name, extension } = report || {};

  const url = getBlobUrl(data, extension);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', [name, extension].filter(Boolean).join('.'));
  document.body.appendChild(link);
  link.click();
  link.remove();
};
